import {
  BanknoteArrowDown,
  Menu,
  ShoppingCart,
  ShoppingCartIcon,
  User2,
} from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/ownfood.png";
import { DashBoardLink } from "../../Helper/config";
import ShowLocation from "../Common/ShowLocation/ShowLocation";
import SideBar from "../Common/SideBar/SideBar";
import DrawerRight from "./DrawerRight";
import "./Header.css";
import ProfileDropdown from "./ProfileDropdown";
import SearchBar from "./SearchBar/SearchBar";
import { clearSession, getStoredUser } from "../../services/auth.api";

const NavigationBar = ({
  paneLeft,
  SetpanLeft,
  cart = [],
  state,
  setState,
  userAddress,
  setUserAddress,
}) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const checkUser = () => setUser(getStoredUser());

    checkUser(); // On mount

    window.addEventListener("storage", checkUser);

    return () => window.removeEventListener("storage", checkUser);
  }, []);
  const handleLogout = () => {
    clearSession();
    window.location.reload(false);
  };

  return (
    <>
      <SideBar SetpanLeft={SetpanLeft} paneLeft={paneLeft} />
      <DrawerRight cart={cart} state={state} setState={setState} />
      <nav className="Header navbar" style={{ padding: "0px" }}>
        <ShowLocation
          userAddress={userAddress}
          setUserAddress={setUserAddress}
        />
        <div className="navbar-container container">
          {/* Left Section - Menu and Logo */}
          <div className="navbar-left">
            <button
              onClick={(e) => {
                e.preventDefault();
                SetpanLeft(true);
              }}
              className="menu-button"
            >
              <Menu size={24} color="#6b7280" />
            </button>
            <Link to={"/"}>
              <div className="logo-container">
                <div className="logo-icon">
                  <img src={logo} alt="Logo" />
                </div>
              </div>
            </Link>

            {/*Global Search box */}
            <SearchBar />
          </div>

          {/* Center Section - Action Buttons */}
          <div className="navbar-center d-none d-xxl-flex">
            <Link to={"/earn-money"} className="action-button">
              <span>Earn Money</span>
              <span>
                <BanknoteArrowDown />
              </span>
            </Link>

            <Link to={"/all-food"} className="action-button">
              <span>Order Now</span>
              <span>
                <ShoppingCartIcon />
              </span>
            </Link>
          </div>

          {/* Right Section - User Controls */}
          <div className="navbar-right">
            <Link to={"/become-seller"} className="text-link d-none d-xl-block">
              Become a Seller
            </Link>

            <button
              onClick={() => {
                setState({ isPaneOpen: true });
              }}
              className="cart-button"
            >
              <ShoppingCart size={24} color="#6b7280" />
              <span className="cart-badge">{cart.length || 0}</span>
            </button>

            {user != null ? (
              <ProfileDropdown
                userDetails={user}
                dashboardLink={DashBoardLink}
                onLogout={handleLogout}
              />
            ) : (
              <button className="login-button">
                <User2 size={16} color="#6b7280" />
                <span className="login-text">
                  <Link to={"/authentication/login"}>Login</Link>{" "}
                  <span className="d-none d-lg-inline-block">/</span>{" "}
                  <Link
                    to={"/authentication/register"}
                    className="d-none d-lg-inline-block"
                  >
                    Register
                  </Link>
                </span>
              </button>
            )}
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavigationBar;
